module.exports = "<a href=\"#\" class=\"btn btn-primary mt-2\" (click)=\"download()\">Exportar para CSV</a>\n"